import React from 'react'
import { params } from '../../../../../../redux/reducers/reducer';
import WallNameTemplate from '../../../../WallName/WallNameTemplete';

const WallName = () => {

    let wallTemplates = [
        { position: [-(params.p_w / 2 + params.lean_p_d + 1), 0, 0], rotation: [0, -Math.PI / 2, 0], slopeAngle: 60, value: 'Left Building Front' },
        { position: [-(params.p_w / 2 + params.lean_p_d / 2), 0, params.lean_p_w / 2 + 1], rotation: [0, 0, 0], slopeAngle: 60, value: 'Left Building Right' },
        { position: [-(params.p_w / 2 + params.lean_p_d / 2), 0, -(params.lean_p_w / 2 + 1)], rotation: [0, Math.PI, 0], slopeAngle: 60, value: 'Left Building Left' }
    ]   
    if(params.add_storage_check) {
        if (params.leftLeanStoragePosition !== params.lean_p_d - parseInt(params.add_storage)) {
            let positionZ = -(params.p_w / 2 + parseInt(params.add_storage) + params.leftLeanStoragePosition);
            let leftStorage = {
                position: [positionZ, 0, 0], 
                rotation: [0, -Math.PI / 2, 0], 
                slopeAngle: 60,
                value: 'Left Building Storage Front' 
                };

            wallTemplates = [...wallTemplates,leftStorage]
        }
        if (params.leftLeanStoragePosition !== 0) {
            let positionZ = -(params.p_w / 2 + params.leftLeanStoragePosition);
            let leftStorage = {
                position: [positionZ, 0, 0], 
                rotation: [0, Math.PI / 2, 0], 
                slopeAngle: 60,
                value: 'Left Building Storage Back' 
                };

            wallTemplates = [...wallTemplates,leftStorage]
        }
    }
    
    return (
        <>
            {wallTemplates.map((template, index) => (
                <WallNameTemplate
                    key={index}
                    position={template.position}
                    rotation={template.rotation}
                    value={template.value}
                    slopeAngle={template.slopeAngle}
                />
            ))}
        </>
    )
}

export default WallName